module.exports = __webpack_public_path__ + "static/media/icn-comment-resolved.2fc811b3.svg";